import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW7005Component } from './kymw7005.component';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetFeatureListService } from './api-services/get-feature-list.service';
import { GetFeatureGoodsService } from './api-services/get-feature-goods.service';

@NgModule({
  declarations: [
    KYMW7005Component
  ],
  imports: [
    CommonModule,
    FormsModule,
    WjGridModule,
    WjGridFilterModule,
    AppCommonsModule,
  ],
  providers: [
    GetFeatureListService,
    GetFeatureGoodsService,
  ],
})
export class KYMW7005Module { }
